export default __webpack_public_path__ + "static/media/basket_ticket.6ca99300.png";